export function getDamageReductionPercent(monsterLvl, playerLvl) {
  const delta = monsterLvl - playerLvl - 1;
  if (delta < 0) return 0;
  if (delta === 0) {
    const coef = 1.035;
    return (1 - 1 / coef) * 100;
  }
  const coef = 1.035 * Math.pow(1.25, delta);
  return (1 - 1 / coef) * 100;
}
